import InputSlider from './range';
export default InputSlider